import React, {useContext, useEffect, useState} from "react";
import { Link, useParams } from "react-router-dom";
import FB from "../../../assets/images/fbb.svg";
import Whatsapp from "../../../assets/images/whatsapp.svg";
import Copy from "../../../assets/images/copy.svg";
import DisplayImg from "../../../assets/images/blog-imgs.png";
import Footer from "../../../components/Footer/Footer";
import {getBlogItems} from "../../../store/actions/adminActions";
import {useDispatch, useSelector} from "react-redux";
import parse from "html-react-parser";
import EducareNavBar from "../../../components/EducareNavBar/EducareNavBar";
import {toast} from "react-toastify";

import "./news.scss";
import {FacebookShareButton, WhatsappShareButton} from "react-share";
import Icon1 from "../../../assets/images/blue-fb.svg";
// import {AdsenseExample} from "../../../components/AdsenseExample/AdsenseExample";
import dynamicComponent from "../../../components/AdsenseExample/dynamicImport"
import AuthContext from "../../../context/AuthProvider";
import {NavbarAdmin} from "../../../components/Navbar/NavbarAdmin";
import {NavbarBusiness} from "../../../components/Navbar/NavbarBusiness";
import {Navbar} from "../../../components/Navbar/Navbar";
import {ADMIN_ROLES, BUSINESS_ROLES} from "../../../api/urls";
import JsxParser from "react-jsx-parser";
const Advert = dynamicComponent(() => import("../../../components/AdsenseExample/AdsenseExample"));
export const MainNews = () => {
  const { user, roles } = useContext(AuthContext);
  const isAdmin = roles?.find(role => ADMIN_ROLES?.includes(role));
  const isBusiness = roles?.find(role => BUSINESS_ROLES?.includes(role));
  const { blog_id } = useParams();
  const { blogsdata } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBlogItems({blog_id:blog_id}));
  }, [blog_id]);

  function copyInviteCode() {
    navigator.clipboard.writeText(
        `${blogsdata.url}`
    );
    toast.success("Copied!");
  }

  const title = "Visit educare Exam portal Blog";
  const testStr = `
<div>
  <h3>Title from string</h3>
  <Ad />
  <B />
</div>`;

  return (
    <>
      {!!!user?<EducareNavBar />:(isAdmin?(<NavbarAdmin />):(isBusiness ? <NavbarBusiness /> : <Navbar />))}
      {blogsdata.blog ? (
        <>
          <div className="col-md-10 offset-md-1 d-md-flex mobile-padding main-news-body">
            <div className="col-md-7 ">
              {" "}
              <div
                className=" main-img2 "
                // style={{ backgroundImage: `url(${blogsdata.blog.img})` }}
              >
                <img src={blogsdata.blog.thumbnail} width="100%" />
              </div>
            </div>
            <div className="  news-body">
              <h4>{blogsdata.blog.title}</h4>

              {/*<p>{parse(blogsdata.blog.content)}</p>*/}
             <div>
               <div className="flexy mt8">
                 <ul className="list-unstyled list-inline share">
                   <li className="list-inline-item">
                     <button onClick={copyInviteCode} className="copied-btn">
                       {" "}
                       <img src={Copy} width="20px" />
                       Copy link
                     </button>
                   </li>
                   <li className="list-inline-item">
                     <FacebookShareButton url={blogsdata.url} className="Demo__some-network__share-button">
                       <img src={FB} width="40px" />
                     </FacebookShareButton>
                   </li>
                   <li className="list-inline-item">
                     <WhatsappShareButton
                         url={blogsdata.url}
                         title={title}
                         separator=":: "
                         className="Demo__some-network__share-button"
                     >
                     <img src={Whatsapp} width="40px" />
                     </WhatsappShareButton>
                   </li>

                 </ul>
               </div>
                <p style={{ color: "#605F5F" }}>Published: {blogsdata.blog.date}</p>
             </div>
            </div>
            {/* <div className="col-md-3 offset-md-1">
              <h3>Older News</h3>
              <div className="row row-cols-1 row-cols-lg-1">
                {state.list.map((blogsdata.blog, index) => (
                  <News blogsdata.blog={blogsdata.blog} key={blogsdata.blog.id} />
                ))}
              </div>
            </div> */}
          </div>
          <div className="col-md-6 offset-md-3 blog-extra-details mobile-padding mt6">
            {/*{parse(blogsdata.blog.content)}*/}
            <JsxParser components={{ Advert }} jsx={blogsdata.blog.content} />
            <hr />
            <div className="d-flex">
              {" "}
              <h6 style={{ flexGrow: 1 }}>Share this post</h6>
              <ul className="list-unstyled list-inline share">
                <li className="list-inline-item">
                  <button onClick={copyInviteCode} className="copied-btn">
                    {" "}
                    <img src={Copy} width="20px" />
                    Copy link
                  </button>
                </li>
                <li className="list-inline-item">
                  <FacebookShareButton url={blogsdata.url} className="Demo__some-network__share-button">
                    <img src={FB} width="40px" />
                  </FacebookShareButton>
                </li>
                <li className="list-inline-item">
                  <WhatsappShareButton
                      url={blogsdata.url}
                      title={title}
                      separator=":: "
                      className="Demo__some-network__share-button"
                  >
                    <img src={Whatsapp} width="40px" />
                  </WhatsappShareButton>
                </li>

              </ul>
            </div>
            {/*<AdsenseExample />*/}
          </div>
        </>
      ) : (
        ""
      )}
      <div className="col-md-8 offset-md-2 flexy prefooter mt mobile-padding">
        <div className="col-md-6">
          <h1>
            Start Your
            <br /> Exam Journey Now ⚡︎
          </h1>
          <p>
            Embrace the power of technology and learning and let's help you ace
            your exams
          </p>
        </div>
        <div className="col-md-3 offset-md-3">
          <Link to={"/authenticate"}>
            <button>Join Now</button>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};
